import _ from 'lodash'
import dishApi from '@/api/dish'
import store from '@/store'
import form from './form'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  errors: [],
  loading: false,
  filters: {
    pageNumber: 1,
    pageCount: 1,

    pageSize: 20,
    searchQuery: '',
    menuCategoryId: 0,
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {}

const actions = {
  fetchList({ commit }) {
    state.loading = true
    dishApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
  },
}

const mutations = {
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
    state.filters.pageNumber = metadata.pageNumber
    state.filters.pageCount = metadata.pageCount
  },
  ...generateFormHandlerMutations(state),
}

const modules = {
  form,
}

const watchers = [
  [state => state.dish.filters, _.debounce(async () => await store.dispatch('dish/fetchList')), {
    immediate: false,
    deep: true,
  }],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
